// configurable: const spacing = useResponsiveSpacing(1, 2, 3);

import { useMediaQuery, useTheme } from "@mui/material";

const useResponsiveSpacingGrid = (
  xsSpacing = 2,
  mdSpacing = 3,
  lgSpacing = 4
) => {
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const isMedium = useMediaQuery(theme.breakpoints.only("md"));

  if (isLarge) return lgSpacing;
  if (isMedium) return mdSpacing;
  return xsSpacing;
};

export default useResponsiveSpacingGrid;
